<ce-layout-footer-container class="ReceiptLookupFooter-container">
    <div class="ReceiptLookupFooter-content flex-center u-spacing-3xl-pb u-body-sm">
        @if (supportContact()) {
        <p class="ReceiptLookupFooter-content-question u-color-text-primary">
            Can't find your receipt?
            <span class="ReceiptLookupFooter-content-link u-color-text-primary">{{ supportContact() }}</span>
        </p>
        }
        <p class="ReceiptLookupFooter-content-powered u-color-text-secondary">Powered by Kempower ChargEye</p>
    </div>
</ce-layout-footer-container>
